module.exports = __webpack_public_path__ + "img/warabee2.b9a65962.png";